const products = [
  //BRAMA
  {
    company: 'brama',
    name: 'brama_baursak',
    pic: 'img/brama/brama_baursak.png',
    title: 'Рыбные бауырсаки (шарики)',
    description: 'Рыбные баурсаки BRAMA – новый продукт на казахстанском рынке с хорошо известным аппетитным названием!<br/><br/>Продукт приготовлен из отборного рыбного филе, преимущественно из леща, и может подаваться к столу как горячая или холодная закуска, или как самостоятельное блюдо.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '400 гр короб'
      },
      {
        text: 'Короб',
        number: '12 кг'
      },
      {
        text: 'Срок годности',
        number: '12 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_bitochki',
    pic: 'img/brama/brama_bitochki.png',
    title: 'Рыбные биточки',
    description: 'Рыбные биточки BRAMA изготовлены из натуральных ингредиентов, в которых сохранены все питательные вещества, а также набор микро и макроэлементов, делающие мясо рыбы таким вкусным и полезным.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '300 гр короб'
      },
      {
        text: 'Короб',
        number: '18 кг'
      },
      {
        text: 'Срок годности',
        number: '12 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_nuggets',
    pic: 'img/brama/brama_nuggets.png',
    title: 'Рыбные наггетсы',
    description: 'Любите вкусную рыбку, тогда наши аппетитные наггетсы – это то, что нужно!<br/><br/>Вам и Вашим детям понравятся рыбные наггетсы BRAMA, насыщенные полноценным животным белком, но достаточно низкокалорийные.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '250 гр короб'
      },
      {
        text: 'Короб',
        number: '15 кг'
      },
      {
        text: 'Срок годности',
        number: '12 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_pelmeni_farsh_soma',
    pic: 'img/brama/brama_pelmeni_farsh_soma.jpg',
    title: 'Любительские пельмени',
    description: '',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '400 гр лоток'
      },
      {
        text: 'Короб',
        number: '12 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_pelmeni_lososeviy_farsh',
    pic: 'img/brama/brama_pelmeni_lososeviy_farsh.jpg',
    title: 'Премиальные пельмени',
    description: '',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '400 гр лоток'
      },
      {
        text: 'Короб',
        number: '12 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_pelmeni_pasta_iz_lesha_originalnie',
    pic: 'img/brama/brama_pelmeni_pasta_iz_lesha_originalnie.jpg',
    title: 'Оригинальные пельмени',
    description: '',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '400 гр лоток'
      },
      {
        text: 'Короб',
        number: '12 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_pelmeni_pasta_iz_lesha_prazdnichnie',
    pic: 'img/brama/brama_pelmeni_pasta_iz_lesha_prazdnichnie.jpg',
    title: 'Праздничные пельмени',
    description: '',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '400 гр лоток'
      },
      {
        text: 'Короб',
        number: '12 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_pelmeni_s_farshem_sudaka',
    pic: 'img/brama/brama_pelmeni_s_farshem_sudaka.jpg',
    title: 'Диетические пельмени',
    description: '',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '400 гр лоток'
      },
      {
        text: 'Короб',
        number: '12 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'brama',
    name: 'brama_strips',
    pic: 'img/brama/brama_strips.png',
    title: 'Рыбные палочки',
    description: 'Рыбные палочки BRAMA – вкусная и полезная закуска.<br/><br/>Горячие рыбные палочки BRAMA из натурального рыбного фарша полюбились нашим покупателям, так как их легко приготовить в любой ситуации, и они всегда под рукой. Хрустящее и вкусное блюдо, которое понравится обязательно вашей семье.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '250 гр короб'
      },
      {
        text: 'Короб',
        number: '12 кг'
      },
      {
        text: 'Срок годности',
        number: '12 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  // RIBPROM
  {
    company: 'ribprom',
    name: 'farsh_ribniy',
    pic: 'img/ribprom/farsh_ribniy.png',
    title: 'Рыбный Фарш',
    description: 'Рыбный фарш изготавливается из мяса пресноводных рыб, очищенного от костей и прошедшего обработку и санитарный контроль',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'file_okunya',
    pic: 'img/ribprom/file_okunya.png',
    title: 'Филе Окуня',
    description: 'Окунь в Казахстане распространен практически повсеместно и имеет промысловое значение. Эта рыбка имеет очень выразительную и яркую окраску.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'file_sazana',
    pic: 'img/ribprom/file_sazana.png',
    title: 'Филе Сазана',
    description: 'Сазан является одной из самых популярных видов рыб. Эта рыба знакома и любима нашими покупателям и отвечает своими полезными и вкусовыми качествами традиционной рыбной кухне.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'file_shyki',
    pic: 'img/ribprom/file_shyki.png',
    title: 'Филе Щуки',
    description: 'Мясо щуки из-за низкого содержания жира, 2-3%, является диетическим продуктом. Благодаря этому продукция из щуки незаменима при низкокалорийном питании.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'file_soma',
    pic: 'img/ribprom/file_soma.png',
    title: 'Филе Сома',
    description: 'Сом – один из ярких представителей казахстанской водной фауны.  Размеры сома достигают 4 метров и более.  Максимальный вес около 200 кг.  Этот гигант обитает преимущественно в теплых водоемах.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'file_sudaka',
    pic: 'img/ribprom/file_sudaka.png',
    title: 'Филе Судака',
    description: 'Судак - самый распространенный хищник в водоемах Казахстана. Белое диетическое мясо этой рыбы сделало судака одним из самых популярных в гастрономическом смысле видов.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'file_zmeegolova',
    pic: 'img/ribprom/file_zmeegolova.png',
    title: 'Филе Змееголова',
    description: 'Змееголов – относительно недавно появившаяся промысловая рыба в таких водоёмах как озеро Балхаш, Капшагайское водохранилище. Ранее эта рыба была распространена в водоёмах Арало-Сырдарьинского бассейна. Ввиду отсутствия мелких костей (только хребет) из неё получаются не только вкусные котлеты, заливное, но и хе.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'shechki_sudaka',
    pic: 'img/ribprom/shechki_sudaka.png',
    title: 'Щечки судака',
    description: 'С давних пор щечки судака считаются эксклюзивным блюдом и всегда подаются отдельно от тушки. По мнению гурманов эта часть рыбы является самой вкусной!',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'tushka_karasya',
    pic: 'img/ribprom/tushka_karasya.jpg',
    title: 'Тушка Карася',
    description: 'Карась в Казахстане представлен двумя видами. Это обыкновенный, или золотой карась и серебряный  карась. Принципиальное отличие этих двух видов – размер.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '-'
      },
      {
        text: 'Короб',
        number: '-'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'tushka_sazana',
    pic: 'img/ribprom/tushka_sazana.jpeg',
    title: 'Тушка Сазана',
    description: 'Сазан является одной из самых популярных видов рыб. Эта рыба знакома и любима нашими покупателям и отвечает своими полезными и вкусовыми качествами традиционной рыбной кухне.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '-'
      },
      {
        text: 'Короб',
        number: '-'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'tushka_foreli',
    pic: 'img/logo.png',
    title: 'Тушка Форели',
    description: 'Форель — одна из популярнейших видов рыб, имеющая потрясающие вкусовые качества. Мясо форели высоко насыщенно и богато различными, полезными минералами и витаминами.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '-'
      },
      {
        text: 'Короб',
        number: '-'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'tushka_mintai',
    pic: 'img/logo.png',
    title: 'Тушка Минтая',
    description: 'Минтай – самый многочисленный вид отряда тресковых. Минтай обитает в Тихом океане - от Берингова моря до Корейского полуострова. Минтай богат на витамин РР, в нем много фосфора, калия, серы, йода, фтора.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '-'
      },
      {
        text: 'Короб',
        number: '-'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'file_foreli',
    pic: 'img/logo.png',
    title: 'Филе Форели',
    description: 'Форель — одна из популярнейших видов рыб, имеющая потрясающие вкусовые качества. Мясо форели высоко насыщенно и богато различными, полезными минералами и витаминами.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  {
    company: 'ribprom',
    name: 'farsh_foreli',
    pic: 'img/logo.png',
    title: 'Форелевый Фарш',
    description: 'Форелевый фарш — идеальный конструктор для кулинарных экспериментов. Помимо пельменей и котлет из него можно наколдовать ещё много сочных, нежных и быстрых блюд.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '1 кг пакет'
      },
      {
        text: 'Короб',
        number: '10/20 кг'
      },
      {
        text: 'Срок годности',
        number: '6 месяцев'
      },
      {
        text: 'Температура хранения',
        number: '- 18 С'
      },
    ]
  },
  //KLEVIE
  {
    company: 'klevie',
    name: 'solomka_lesha',
    pic: 'img/logo.png',
    title: 'Соломка леща',
    description: 'Соломка леща вяленого отличный вариант к холодному пиву. Продукт не содержит консервантов, химических добавок, усилителей вкуса, красителей и ароматизаторов. Только рыба и соль. Тонкие палочки из нежной мякоти леща невероятно аппетитные и не прилипают к зубам.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '50 гр пакет'
      },
      {
        text: 'Короб',
        number: '5 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
    ]
  },
  {
    company: 'klevie',
    name: 'solomka_vobli',
    pic: 'img/logo.png',
    title: 'Соломка воблы',
    description: 'Соломка вяленой воблы с характерным солоноватым вкусом идеально подходит под пенные напитки. Мякоть рыбы и соль — единственные ингредиенты. Продукт получается сухим, но мягким, сохраняет свою текстуру, равномерно просолен.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '50 гр пакет'
      },
      {
        text: 'Короб',
        number: '5 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
    ]
  },
  {
    company: 'klevie',
    name: 'klevie_lesh_spinka',
    pic: 'img/klevie/klevie_lesh_spinka.jpg',
    title: 'Спинка леща чищенная',
    description: 'Полезные вещества, содержащиеся в леще, прекрасно сохраняются после вяления. Регулярное потребление этой рыбы в разных видах восстанавливает кожный покров, регулирует обменные процессы, улучшает работу сердечно-сосудистой системы.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '100 гр пакет'
      },
      {
        text: 'Короб',
        number: '5 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
    ]
  },
  {
    company: 'klevie',
    name: 'klevie_lesh',
    pic: 'img/klevie/klevie_lesh.png',
    title: 'Лещ вяленый неразделанный',
    description: 'Лещ – рыба пресноводная, относится к семейству карповых. Издревле она – желанная гостья на столе. Леща варят и жарят, запекают и тушат. Однако особой популярностью пользуется вяленый лещ.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '500 гр пакет'
      },
      {
        text: 'Короб',
        number: '5 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
      {
        text: 'Упаковка',
        number: '1 кг короб'
      },
      {
        text: 'Короб',
        number: '3 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
    ]
  },
  {
    company: 'klevie',
    name: 'klevie_vobla_spinka',
    pic: 'img/klevie/klevie_vobla_spinka.jpg',
    title: 'Спинка воблы чищенная',
    description: 'Вяленая спинка воблы  прекрасная закуска, давно завоевавшая любовь среди любителей пива.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '100 гр пакет'
      },
      {
        text: 'Короб',
        number: '5 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
    ]
  },
  {
    company: 'klevie',
    name: 'klevie_vobla',
    pic: 'img/klevie/klevie_vobla.png',
    title: 'Вобла вяленая неразделанная',
    description: 'Вобла вяленая, пожалуй, самая простая и традиционная закуска к пиву. Готовится она следующим образом: свежая рыба подсаливается, а затем сушится (вялится) на воздухе.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: '500 гр пакет'
      },
      {
        text: 'Короб',
        number: '5 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
      {
        text: 'Упаковка',
        number: '1 кг короб'
      },
      {
        text: 'Короб',
        number: '3 кг'
      },
      {
        text: 'Срок годности',
        number: '4 месяца'
      },
      {
        text: 'Температура хранения',
        number: 'От 0 до -8 С'
      },
    ]
  },
  {
    company: 'klevie',
    name: 'klevie_polukolca_kopchenie',
    pic: 'img/klevie/klevie_polukolca_kopchenie.jpg',
    title: 'Полукольца кальмара копченые',
    description: 'Полукольца кальмара копчёные – это полуколечки, сохранившие природную нежную текстуру кальмара, с золотистым цветом и копченым ароматом. Являются самостоятельной закуской.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: ''
      },
      {
        text: 'Короб',
        number: ''
      },
      {
        text: 'Срок годности',
        number: ''
      },
      {
        text: 'Температура хранения',
        number: ''
      },
    ]
  },
  {
    company: 'klevie',
    name: 'klevie_solomka_kalmara',
    pic: 'img/klevie/klevie_solomka_kalmara.jpg',
    title: 'Соломка кальмара солено-сушеная',
    description: 'Сушёно-вяленый кальмар – натуральный продукт, отличный деликатес и традиционная закуска к пиву.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: ''
      },
      {
        text: 'Короб',
        number: ''
      },
      {
        text: 'Срок годности',
        number: ''
      },
      {
        text: 'Температура хранения',
        number: ''
      },
    ]
  },
  {
    company: 'klevie',
    name: 'klevie_struzhka_kalmara',
    pic: 'img/klevie/klevie_struzhka_kalmara.jpg',
    title: 'Стружка кальмара со вкусом краба',
    description: 'Стружка кальмара - одна из самых любимых закусок для пива, которая не теряет своей популярности на протяжении долгого времени. Приятный привкус краба дополняет вкус кальмара и отлично подходит как к пивным напиткам, так и любым другим.',
    additionalInfo: [
      {
        text: 'Упаковка',
        number: ''
      },
      {
        text: 'Короб',
        number: ''
      },
      {
        text: 'Срок годности',
        number: ''
      },
      {
        text: 'Температура хранения',
        number: ''
      },
    ]
  }
]

const background = [
  {
    company: 'brama',
    pic: 'img/background/brama.jpg'
  },
  {
    company: 'klevie',
    pic: 'img/background/klevie.jpg'
  },
  {
    company: 'ribprom',
    pic: 'img/background/ribprom.jpg'
  },
]

export {
  products,
  background
}